import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Participant } from '@/types';

interface UserState {
  participant: Participant | null;
  isRegistered: boolean;
  setParticipant: (participant: Participant) => void;
  updateParticipant: (updates: Partial<Participant>) => void;
  clearParticipant: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      participant: null,
      isRegistered: false,

      setParticipant: (participant) =>
        set({
          participant,
          isRegistered: true,
        }),

      updateParticipant: (updates) =>
        set((state) => ({
          participant: state.participant
            ? { ...state.participant, ...updates }
            : null,
        })),

      clearParticipant: () =>
        set({
          participant: null,
          isRegistered: false,
        }),
    }),
    {
      name: 'greater-heights-user',
      // Only persist specific fields
      partialize: (state) => ({
        participant: state.participant,
        isRegistered: state.isRegistered,
      }),
    }
  )
);